<template>
  <div class="vouchers">
    <div class="wrap">
    <div class="tab">
      <div class="item" :class="active==1?'active':''" @click="tabselect(1)">
        <span>待领取</span>
      </div>
      <div class="item" :class="active==2?'active':''" @click="tabselect(2)">
        <span>已领取</span>
      </div>
    </div>
      <div class="content">
        <div class="vochersbanner" v-if='ad&&active==1'>
          <img :src="ad.adPicture" alt="" @click="jumpactivity">
        </div>
        <!-- <div class="monthcard" v-if="(monthcardstatus==2||monthcardstatus==3)&&active==1">
          <div class="monthcardMoney">￥<span>{{monthcardContent.amount/100}}</span>
          <p class="monthcardtext">{{monthcardContent.couponDesc}}</p>
          </div>
          <div class="monthcardBtn" @click="jumpmonthurl">领取</div>
        </div> -->
        <div class="nonum" v-if='active ==2 &&list.length==0'>
          <img src="../assets/img/nonum@2x.png" alt="">
          <p>暂无数据</p>
        </div>
        <div class="nonum" v-else-if='list.length==0&&!ad'>
          <img src="../assets/img/nonum@2x.png" alt="">
          <p>暂无数据</p>
        </div>
        <div v-for="item in list" :key="item.id" class="content_item_wrap" :class="item.receiveCouponMethods==1?'shadow':''">
           <div class="content_item" :class="item.receiveCouponMethods==1?'h5':''">
             <div class="money">
               <p class="amount"><span>￥</span>{{item.amount|money}}</p>
               <p class="ruleamount">消费满{{item.ruleAmount|money}}元可用</p>
             </div>
            <div class="contenttext">
            <p class="titlefont over_more">{{item.couponName}}</p>
            <p class="timecontent timelineheight" v-if="active==2||item.validityType==1">有效期：</br><span class="nowrap">{{item.startTime|formatDate}}-{{item.endTime|formatDate}}</span></p>
            <p class="timecontent timelineheight" v-if="item.validityType==2&&active==1">领取后{{item.validityDay}}天内有效</p>
            </div>
          <div class="lqbtn giftbtn" @click="lingqu(item)" :class="active==2?'userd':''">
            {{active==1?'领取':'已领取'}}
          </div>
          </div>
          <div class="coupontype" v-show="item.receiveCouponMethods==1">
            只限APP可领取
          </div>
        </div>
      </div>
      <!-- <div class="oldcontent" v-if="active==2">
        <div class="content_item" v-for="item in list" :key="item.id">
          <div class="contenttext">
          <p class="titlefont">{{item.giftName}}</p>
          <p class="giftcontent">{{item.giftContent}}</p>
          </div>
        <div class="lqbtn giftbtn" @click="lingqu(item)">
          复制
        </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5';
import {getvouchers,getvouchersed,getvouchersnum,getAppModuleCon,getMonthCardInfo} from '@/api/vouchers'
export default {
   data(){
     return {
       active:1,
       list:[],
       form:{
        userId:'',
        productId:'',
        channelId:'',
        osType:''
      },
        lingqustate:false,
        pagebag:'',
        pageurl:'',
        scId:'',
        ad:{},
        monthcardstatus:0,
        monthcardContent:{},
        jumplist:[
          {
            packageName:'',
            togoOther:'togoWebViewActivity',
            url:''
          },
          {
            packageName:'',
          },
          {
            
          },
          {

          },
          {
            packageName:'',
            togoOther:'togoGameDetailActivity',
            productId:'',
          },
          {
            packageName:'',
            togoOther:'togoGameDetailActivity',
            productId:'',
            actionType:'toGoGift'
          },
          {
            packageName:'',
            togoOther:'togoGameDetailActivity',
            productId:'',
            actionType:'toGoCoupon'
          },
          {},
          {}
        ],
        jumpmonth:{}
     }
   },
   created(){
     if(this.$route.query.osType){
      this.form.osType = this.$route.query.osType
      this.form.channelId = this.$route.query.channelId
      this.form.productId = this.$route.query.productId
      this.form.userId = this.$route.query.userId
     }
     getvouchers(this.form).then(res=>{
      if(res.data.code == 200){
        this.list = res.data.data.coupons||[]
        this.ad = res.data.data.couponAd
        if(this.form.channelId == 100){
          this.pagebag = 'com.sssy.market'
          this.pageurl = 'http://game683.com/?scId='+res.data.data.scId
        }else{
          this.pagebag = 'com.player.gamestation'
          this.pageurl = 'http://gamexiaoai.com/?channelId='+this.form.channelId+'&scId='+res.data.data.scId
        }
      }
     })
    //  if(this.$route.query.deviceId){
    //    this.getMonthCard()
    //  }
   },
   filters:{
     money(val){
       return val/100
     },
     formatDate(data) {
        if(!data){return '-'}
        //时间戳是整数，否则要parseInt转换
        var time = new Date(data*1000); // 需要使用Date格式进行日期转化，若是时间戳、字符串时间，需要通过new Date(..)转化
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        // return y+'-'+isZero(m)+'-'+isZero(d)+' '+isZero(h)+':'+isZero(mm)+':'+isZero(s);
        return y+'.'+isZero(m)+'.'+isZero(d);
        function isZero(m){
        return m<10?'0'+m:m
        }
    }
   },
   methods:{
    //  月卡引导跳转
     jumpmonthurl(){
       const that = this
      if(this.form.osType == 1){
        try{
          window.SDK.openapp(that.jumpmonth.appJumpPageType,that.jumpmonth.jumpType,that.jumpmonth.appPlatformProductId,that.jumpmonth.sdkJumpUrl,that.jumpmonth.appJumpUrl)
        }catch(error){
          console.log(error)
        }
      }else if(this.form.osType == 2){
        try{
          const jsonstr = JSON.stringify(that.jumpmonth)
          window.webkit.messageHandlers.iosjump.postMessage(jsonstr);
        }catch(error){
          console.log(error)
        }
      }
     },
    //  获取月卡信息
     getMonthCard(){
       var form = JSON.parse(JSON.stringify(this.form))
       form.deviceId = this.$route.query.deviceId
       form.mcPosition = 2
       getMonthCardInfo(form).then(res=>{
         if(res.data.code == 200){
            this.jumpmonth = res.data.data
            this.monthcardstatus = res.data.data.status
            // this.monthcardContent = res.data.data.vipConfigCard||{}
            if(!res.data.data.vipConfigCard&&this.monthcardstatus == 3){
              this.monthcardstatus = 1
            }else if(!res.data.data.vipCouponCard&&this.monthcardstatus == 3){
              this.monthcardstatus = 1
            }

            if(this.monthcardstatus == 3){
              this.monthcardContent = res.data.data.vipConfigCard||{}
            }else {
              this.monthcardContent = res.data.data.vipCouponCard||{}
            }
         }
       })
     },
     jumpactivity(){
       const that = this
       if(this.form.osType == 1){
        try{
          window.SDK.openapp(that.ad.appJumpPageType,that.ad.jumpType,that.ad.appPlatformProductId,that.ad.sdkJumpUrl,that.ad.appJumpUrl)
        }catch(error){
          if(that.form.channelId == 27||that.form.channelId == 100||that.form.channelId == 200||that.form.channelId == 3){
              that.$Message.show('请前往上上手游APP开通省钱卡')
            }else{
              that.$Message.show('请前往小爱手游APP开通省钱卡')
            }
          // console.log(error)
        }
      }else if(this.form.osType == 2){
        try{
          const jsonstr = JSON.stringify(that.ad)
          window.webkit.messageHandlers.iosjump.postMessage(jsonstr);
        }catch(error){
          console.log(error)
        }
      }
     },
     lingqu(item){
       const that = this
      //  couponGiftKey ：5aSn6Iej5ri45oiP
      if(this.active == 1&&!this.lingqustate&&item.receiveCouponMethods == 0){
        var form = {
        userId:this.form.userId,
        couponId:item.couponId,
        osType:this.form.osType,
        sign:''
      }
      let content = JSON.parse(JSON.stringify(item))
      if(content.endTime == 0){
        let now =new Date().getTime()/1000
        content.endTime = parseInt(now) + 86400*content.validityDay
      }
      this.lingqustate = true
       var str = this.form.userId+''+item.couponId+''+this.form.osType+'5aSn6Iej5ri45oiP'
        form.sign = md5(str)
        getvouchersnum(form).then(res=>{
        if(res.data.code ==200 ){
            this.lingqustate = false
            if(this.form.osType == 1){
              try{
                window.SDK.getcouponsuccess(content.couponName,content.amount,content.ruleAmount,content.startTime,content.endTime)
              }catch(error){
                console.log(error)
              }
            }else if(this.form.osType == 2){
              try{
                const jsonstr = JSON.stringify(content)
                window.webkit.messageHandlers.getcouponsuccess.postMessage(jsonstr);
              }catch(error){
                console.log(error)
              }
            }
          }else{
            this.lingqustate = false
          }
          this.tabselect(1)
        })
      }else if(this.active == 1&&!this.lingqustate&&item.receiveCouponMethods == 1){
          if(this.form.osType == 1){
             try{
              window.SDK.openapp(6,1,item.productId,'','')
            }catch(error){
              try{
                window.SDK.godownpage(this.pagebag,this.pageurl+'&productId='+item.productId)
              }catch(err){
                
                // if(that.form.channelId == 27||that.form.channelId == 100||that.form.channelId == 200||that.form.channelId == 3){
                //   that.$Message.show('请前往上上手游APP操作')
                // }else{
                //   that.$Message.show('请前往小爱手游APP操作')
                // }
                // console.log(err)
                 var form = {
                    userId:this.form.userId,
                    couponId:item.couponId,
                    osType:this.form.osType,
                    sign:''
                  }
                  let content = JSON.parse(JSON.stringify(item))
                  if(content.endTime == 0){
                    let now =new Date().getTime()/1000
                    content.endTime = parseInt(now) + 86400*content.validityDay
                  }
                  this.lingqustate = true
                  var str = this.form.userId+''+item.couponId+''+this.form.osType+'5aSn6Iej5ri45oiP'
                    form.sign = md5(str)
                    getvouchersnum(form).then(res=>{
                    if(res.data.code ==200 ){
                        this.lingqustate = false
                        if(this.form.osType == 1){
                          try{
                            window.SDK.getcouponsuccess(content.couponName,content.amount,content.ruleAmount,content.startTime,content.endTime)
                          }catch(error){
                            console.log(error)
                          }
                        }else if(this.form.osType == 2){
                          try{
                            const jsonstr = JSON.stringify(content)
                            window.webkit.messageHandlers.getcouponsuccess.postMessage(jsonstr);
                          }catch(error){
                            console.log(error)
                          }
                        }
                      }else{
                        this.lingqustate = false
                      }
                      this.tabselect(1)
                    })
              }
              console.log(error)
            }
          }else if(this.form.osType == 2){
            try{
              const jsonstr2 = JSON.stringify({packName:this.pagebag,pageurl:this.pageurl+'&productId='+item.productId,productId:item.productId})
              window.webkit.messageHandlers.godownpage.postMessage(jsonstr2);
            }catch(error){
              console.log(error)
            }
          }
      }else{
        return
      }
     },
     tabselect(num){
       if(num == 1){
         getvouchers(this.form).then(res=>{
           if(res.data.code== 200){
             this.active = num
             if(res.data.data.coupons){
               this.list = res.data.data.coupons
             }else{
               this.list = []
             }
           }
         })
       }else{
         getvouchersed(this.form).then(res=>{
           if(res.data.code== 200){
             this.list = res.data.data
             this.active = num
           }
         })
       }
     }
   }
}
</script>
<style lang="less" scoped>
  .vouchers{
    font-size: 0.7rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .content{
      width: 100%;
      height: 100%;
      background: rgba(247,247,249,0.9);
      padding:2.25rem 0.5rem 0;
      overflow-y: auto;
      .vochersbanner{
        width: 100%;
        height: max-content;
        // background: url(../assets/img/kuang@2x.png) no-repeat;
        background-size: 100% 100%;
        margin-top: 0.6rem;
        display: flex;
        align-items: center;
        // padding: 0.75rem 0.53rem;
        // .bannermoney{
        //   color: #F9E9B7;
        //   font-size: 1.35rem;
        // }
        // .moneybiaodian{
        //   font-size: 0.65rem;
        // }
        // .moneysm{
        //   font-size: 0.55rem;
        //   color: #DACAA2;
        // }
        // .moneybtn{
        //   padding: 0.3rem 0.7rem;
        //   margin-left: auto;
        //   background: linear-gradient(-90deg, #FEE5A2, #FDEBB9);
        //   font-size: 0.55rem;
        //   border-radius: 10px;
        //   text-align: center;
        //   border-radius:1.133333rem; 
        // }
      }
      .monthcard{
        width: 100%;
        background: url(../assets/img/kuang@2x.png);
        height: 3.75rem;
        background-size: 100% 100%;
        margin-top: 0.5rem;
        display: flex;
        justify-content: space-between;
        padding: 0.75rem 1rem 0.75rem 0.5rem;
        .monthcardMoney{
          color: #F9E9B7;
          font-size: 0.65rem;
          span{
            font-size: 1.35rem;
          }
        }
        .monthcardtext{
          color: #DACAA2;
          font-size: 0.55rem;
        }
        .monthcardBtn{
          width: 2.5rem;
          height: 1.15rem;
          background: linear-gradient(-90deg, #FEE5A2, #FDEBB9);
          border-radius: 1rem;
          font-size: 0.65rem;
          text-align: center;
          font-size: 0.55rem;
          font-weight: 500;
          color: #222222;
          line-height: 1.15rem;
          align-self: center;
        }
      }
      .content_item_wrap{
        height: 3.75rem;
        margin-top: 0.5rem;
        // overflow: hidden;
        &.shadow{
          height: 5rem;
          filter: drop-shadow(0 1px 1px rgb(210,210,210));
        }
      .coupontype{
        text-indent: 0.67rem;
        background: 
          radial-gradient(circle at top left, transparent 10px, #F8F8F8 0) top left, 
          radial-gradient(circle at top right, transparent 10px, #F8F8F8 0) top right, 
          radial-gradient(circle at bottom right, transparent 0, #F8F8F8 0) bottom right, 
          radial-gradient(circle at bottom left, transparent 0, #F8F8F8 0) bottom left;
        background-size: 60% 60%;
        background-repeat: no-repeat;
        font-size: 0.5rem;
        height: 1.25rem;
        line-height: 1.25rem;
        border-radius: 0.4rem;
      }
      .content_item{
        width: 100%;
        height:3.75rem; 
        overflow: hidden;
        padding: 0.75rem 0.53rem;
        display: flex;
        justify-content: space-between;
        background: #fff;
        border-radius: 0.4rem;
        &.h5{
          background: 
          radial-gradient(circle at top left, transparent 0, #fff 0) top left, 
          radial-gradient(circle at top right, transparent 0, #fff 0) top right, 
          radial-gradient(circle at bottom right, transparent 10px, #fff 0) bottom right, 
          radial-gradient(circle at bottom left, transparent 10px, #fff 0) bottom left;
          background-size: 60% 60%;
          background-repeat: no-repeat;
        }
        .contenttext{
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          .timelineheight{
            height: 0.75rem;
            line-height: 0.75rem;
            margin-top: 0.25rem;
            transform: translateY(-50%);
          }
        }
        .lqbtn{
          width:2.5rem;
          height:1.15rem;
          background:rgba(245,204,64,1);
          border-radius:1rem;
          margin-left: 0.9rem;
          text-align: center;
          line-height: 1.15rem;
          align-self: center;
          flex-shrink: 0;
          &.userd{
            background: #C2C2C2;
            color: #fff;
          }
        }
        .titlefont{
          width: 4.7rem;
          height: 0.8rem;
          line-height: 0.72rem;
          word-spacing: normal;
          padding-top: 2px;
          padding-bottom: 2px;
        }
        .giftcontent{
          display: flex;
          align-items: center;
          line-height: 0.725rem;
          flex-wrap: wrap;
          flex: 1;
          margin-top: 0.35rem;
        }
        .money{
          color: #F1B82E;
          font-weight:bold;
          font-size: 1rem;
          // display: flex;
          // align-items: center;
          text-align: center;
          border-right: 1px solid #F4F4F4;
          margin-right: 0.48rem;
          width: 4.9rem;
          flex-shrink: 0;
          .amount{
            font-size: 0.9rem;
            span{
            font-size: 0.6rem;
            }
          }
          .ruleamount{
            margin-top: 0.25rem;
            font-size: 0.45rem;
          }
        }
        
        // money
      }
      .outssice{
        width: 100%;
        padding: 0 0.75rem;
        .timecontent{
          width: 100%;
          padding-bottom: 0.55rem;
          border-bottom: 1px dashed #E19839;
        }
        .copynum{
          width: 100%;
          height: 1.58rem;
          line-height: 1.58rem;
        }
      }
    }
      }

  }
  .tab{
    height: 2.25rem;
    width: 100%;
    font-size: 0.7rem;
    line-height: 2.25rem;
    background: #fff;
    box-shadow:0 1px 0 0 rgba(210,210,210,1);
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 100;
    .item{
      width: 50%;
      float: left;
      text-align: center;
      color: #666666;
    }
    .item.active{
      color: #111111;
      span{
        position: relative;
        &::after{
        content: '';
        width: 100%;
        height: 0.2rem;
        background: #F1B82E;
        position: absolute;
        left: 0;
        right: 0;
        top: 1.35rem;
        margin: auto;
        border-radius: 0.1rem 0.1rem 0 0;
        z-index: 10;
        }
      }
    }
  }
</style>
